import { BASE_URL } from '../../utils/network';
import Session from '../../utils/Session';
import { GET_QR_CODE } from "./actionTypes";

export const getQRCode = (controlPointId, handleOnSuccess, handleOnError) => {
    return function (dispatch, getState) {
        const action = {
            type: GET_QR_CODE,
            data: {
                reason: null,
                error: null,
                isLoading: true,
            }
        };
        dispatch(action);

        const apiUrl = BASE_URL + '/api/v1/firebase/control-point/qrcode';
        const headers = {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
            "control-point-id": controlPointId,
            "control-point-token": Session.getAccessCode()
        };

        return fetch(apiUrl, {
            method: 'GET', // *GET, POST, PUT, DELETE, etc.
            headers: headers,
            // body data type must match "Content-Type" header
        }).then(response => response.json())
            .then(data => {
                //success
                if (data.error) {
                    if (handleOnError) handleOnError(data.error, data.reason);
                    action.data.error = data.error;
                    action.data.reason = data.reason;
                } else {
                    action.data.error = null;
                    action.data.reason = null;
                    action.data.qrcode = data.qrcode;
                    if (handleOnSuccess) handleOnSuccess(data)
                }
                //store token
                action.data.isLoading = false;
                dispatch(action);

            })
            .catch((err) => {
                //hadle error
                if (handleOnError) handleOnError(err, null)
                action.data.reason = null;
                action.data.error = err;
                action.data.isLoading = false;
                dispatch(action);
            });
    }
};
